import {
  getEligibleABTestLimit,
  updateEligibleTestLimit,
} from "./testTrackingHelpers";
import { ABTestLimit, DecodedTestInformation } from "./variationId";

export function getExclusiveTestIfEligible(
  testsCurrentlySavedInCookie: DecodedTestInformation[],
  allActiveFeatBitTestsInformation: DecodedTestInformation[],
): DecodedTestInformation | undefined {
  const activeExclusiveTests = allActiveFeatBitTestsInformation.filter(
    (featBitTest) => featBitTest.exclusive,
  );
  if (!activeExclusiveTests.length) return;

  const existingFullTestIds = testsCurrentlySavedInCookie.map(
    (cookieTest) => cookieTest.fullTestId,
  );

  for (const activeTest of activeExclusiveTests) {
    if (existingFullTestIds.includes(activeTest.fullTestId)) {
      return activeTest;
    }
  }

  const remainingTestLimit = getEligibleABTestLimit();
  if (remainingTestLimit < ABTestLimit) return;

  const firstRuleMatchedExclusiveTest = activeExclusiveTests.find(
    (activeExclusiveTest) => activeExclusiveTest.kind === "RuleMatch",
  );
  if (firstRuleMatchedExclusiveTest) {
    return firstRuleMatchedExclusiveTest;
  }
}

export function updateStorageForExclusiveTest(test: DecodedTestInformation) {
  // Set the session storage no matter what, that way any duplicate requests pull from the cache
  sessionStorage.setItem(test.fullTestId, test.variant);
  // If a exclusive test is returned from checkAndGetExclusiveTestIfElligible and does not have 0 as their test, the user has a new exclusve test and should have their limit set to 0
  if (getEligibleABTestLimit() != 0) updateEligibleTestLimit(0);
}
